import { Play as PlayIcon } from '@components/icons'
import { useUI } from '@components/ui'
import useThumbnail from '@lib/hooks/useThumbnail'
import cn from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import useMeasure from 'react-use-measure'

interface VideoCardProps {
  uid: string
  videoUrl: string
  linkType?: string
  title: string
  searchCard?: boolean
  description?: string
}

const VideoCard = ({
  uid,
  videoUrl,
  linkType,
  title,
  searchCard = false,
  description,
}: VideoCardProps) => {
  let [ref, { width, height }] = useMeasure()
  const thumbnailUrl = useThumbnail(videoUrl, {
    time: 0.3,
    width: width,
    height: height,
  })
  const { closeSidebarIfPresent } = useUI()

  return (
    <>
      <Link href={`/video-guide/${uid}`} passHref>
        <div
          className={cn('relative cursor-pointer overflow-hidden', {
            'aspect-4/5': searchCard,
            'aspect-video': !searchCard,
          })}
          onClick={() => closeSidebarIfPresent()}
          ref={ref}
        >
          {thumbnailUrl ? (
            <Image
              alt={title || 'Video Thumbnail'}
              className="scale-150 object-cover transition-transform duration-300 ease-in-out hover:scale-150"
              fill
              src={thumbnailUrl as string}
              sizes="(min-width: 1024px) 25vw, 50vw"
              placeholder="blur"
              blurDataURL={thumbnailUrl || '/product-img-placeholder.svg'}
            />
          ) : null}
          <div className="absolute inset-0 flex items-center justify-center">
            <PlayIcon className="h-10 w-10" />
          </div>
        </div>
        {linkType ? <div className="label-bold pt-2">{linkType}</div> : null}
        <div
          className={cn('label', { 'label-bold pt-3 uppercase': !searchCard })}
        >
          {title}
        </div>
        {description && <div className="body-1 pt-2">{description}</div>}
      </Link>
    </>
  )
}

export default VideoCard
